import { useEffect, useState } from 'react';
import { SelectChangeEvent } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import {
  PercentOffMsrpClassificationLabelType,
  searchPercentOffMsrpClassifications,
} from '../../preferences/actions';
import { SearchItem } from '../../preferences/types';

const searchItemNone: SearchItem = { id: 0, label: 'No preference' };

export const PercentOffMsrpSelector = ({
  initialValue,
  label,
  onChange,
  optionLabel = 'name',
}: {
  initialValue: number | null;
  label: string;
  onChange(event: SelectChangeEvent<any>): void;
  optionLabel?: PercentOffMsrpClassificationLabelType;
}): JSX.Element => {
  const [selected, setSelected] = useState<SearchItem>(searchItemNone);
  const [options, setOptions] = useState<SearchItem[]>([searchItemNone]);

  useEffect(() => {
    async function getAndSetOptions() {
      const options = await searchPercentOffMsrpClassifications(optionLabel);
      setOptions([searchItemNone, ...options]);
      const defaultOption = options.find(({ id }) => id === Number(initialValue));
      if (defaultOption) {
        setSelected(defaultOption);
      }
    }
    getAndSetOptions();
  }, [initialValue, optionLabel]);
  return (
    <TextField
      label={label}
      select
      SelectProps={{
        renderValue: () => {
          const selectedOption = options.find(({ id }) => id === selected.id);
          return (
            <Typography variant="bodySmallLight">
              {selectedOption?.label ?? searchItemNone.label}
            </Typography>
          );
        },
        onChange: (event) => {
          onChange(event);
          setSelected(options.find(({ id }) => id === event.target.value) ?? searchItemNone);
        },
      }}
      fullWidth
      value={selected.id}
      name="percentOffMsrpClassificationId"
      data-testid="percent-off-msrp-search"
    >
      {options.map((option) => (
        <MenuItem value={option.id} key={option.id}>
          <Typography>{option.label}</Typography>
        </MenuItem>
      ))}
    </TextField>
  );
};
